import { mergeBucketCategory } from "../../onethreefive/model/CategoryUtils";
import { GraphClient } from "./GraphClient";
import { GraphClientFactory } from "./GraphClientFactory";
export class UpdateGraphClient extends GraphClient {
    async updateBucket(slot, bucket) {
        var _a;
        // Keep the task's other categories; only swap the one/three/five bucket.
        // Messages aren't todo tasks, so there is nothing to merge with.
        const task = slot.type === 'Message' ? undefined :
            await this.getTask(slot.getTaskId(), slot.type, this.authProvider);
        const client = GraphClientFactory.makeUpdateClient(this.authProvider, slot);
        const updateTask = {
            categories: mergeBucketCategory(task === null || task === void 0 ? void 0 : task.getCategories(), bucket)
        };
        const response = await client.update(updateTask);
        // The cached copy now has the old categories.
        const id = (_a = slot.getTaskId()) === null || _a === void 0 ? void 0 : _a.taskId;
        if (id)
            this.cache.remove(id);
        return response;
    }
}
